import { render, staticRenderFns } from "./PageRecettesListe.vue?vue&type=template&id=fff1cea6&"
import script from "./PageRecettesListe.vue?vue&type=script&lang=js&"
export * from "./PageRecettesListe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports